import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge class names, with later Tailwind utilities winning over earlier ones.
 *
 * `clsx` alone would leave `px-2 px-4` in the string and let CSS source order decide,
 * which makes a component's own prop unable to override its default. `twMerge`
 * understands Tailwind's groups and drops the loser. This is the `cn` every shadcn
 * component expects; it is named `cn` for exactly that reason.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
